import { useTranslation } from "react-i18next";
import BlurRevealText from "./BlurRevealText";

const featureIcons = ["globe", "tower", "shield", "bolt"];

export function FeatureIcon({ type }) {
  const stroke = "#5B9EF5";
  const common = {
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
  };

  if (type === "globe") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="14" stroke={stroke} strokeWidth="1.75" />
        <ellipse cx="20" cy="20" rx="6" ry="14" stroke={stroke} strokeWidth="1.75" />
        <path d="M6 20h28M8 14h24M8 26h24" stroke={stroke} strokeWidth="1.75" />
      </svg>
    );
  }

  if (type === "tower") {
    return (
      <svg {...common}>
        <path
          d="M20 8v24M16 32h8M18 28h4"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <path
          d="M12 16c2-2 6-3 8-3s6 1 8 3M10 22c3-3 7-4 10-4s7 1 10 4M8 28c4-4 8-5 12-5s8 1 12 5"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "shield") {
    return (
      <svg {...common}>
        <path
          d="M20 6l12 5v9c0 8-5 12-12 14-7-2-12-6-12-14V11l12-5z"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinejoin="round"
        />
        <path
          d="M15 20l3 3 7-7"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === "code") {
    return (
      <svg {...common}>
        <path
          d="M14 12l-6 8 6 8M26 12l6 8-6 8M22 10l-4 20"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg {...common}>
      <path
        d="M22 6L12 22h8l-2 12 12-18h-8l2-10z"
        stroke={stroke}
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function GlobalConnected({ label }) {
  const { t } = useTranslation();
  const titleLines = t("globalConnected.titleLines", { returnObjects: true });
  const features = t("globalConnected.features", { returnObjects: true });

  return (
    <section className="global-connected-section">
      <div className="container">
        <div className="global-connected-content">
          <p className="global-connected-label">
            {label || t("globalConnected.label")}
          </p>
          <BlurRevealText
            as="h2"
            className="global-connected-title"
            lines={titleLines}
          />
          <p className="global-connected-desc">
            {t("globalConnected.description")}
          </p>
          <div className="global-connected-features">
            {features.map((item, index) => (
              <div className="global-connected-feature" key={item.label}>
                <FeatureIcon type={featureIcons[index]} />
                <div>
                  <strong className="global-connected-stat">{item.stat}</strong>
                  <span className="global-connected-feature-label">
                    {item.label}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default GlobalConnected;
